export const UPDATECLIENTCREDENTIALS="updateClientCredentials"
export const UPDATECLIENTCREDENTIALS_SUCCESSFULL="updateClientCredentials_successfull"
export const REQUESTOTP = "requestOtp"
export const REQUESTOTP_SUCCESSFULL = "requestOtp_successfull"
export const SUBMIT_GST_CREDENTIALS_OTP = "submit_gst_credentials_otp"
export const SUBMIT_GST_CREDENTIALS_OTP_SUCCESSFULL = "submit_gst_credentials_otp_successfull"


